module.exports = __webpack_public_path__ + "static/board-15-1d93aa94171b580492e898f513581e8a.jpg";